import { Typescratcher as Ts } from "@tscratch3/typescratcher";

// 【画像読み込み】
import sharkPng from "@Assets/shark.png";
export const SharkImage = new Ts.Image( sharkPng );
import WaterSvg from "@Assets/water.svg";
export const WaterImage = new Ts.Image( WaterSvg );